import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import store from "./AsianExchangeSrc/redux/store";

if (import.meta.env.PROD) {
  console.log = () => {};
  console.debug = () => {};
  // console.warn = () => { };
  // console.info = () => {};
  // console.error is still active
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <App />
    <ToastContainer
      position="top-right" 
      autoClose={2000}
      limit={3}
      newestOnTop={true}
      closeOnClick={true} 
      rtl={false} 
      pauseOnFocusLoss={false} 
      draggable={true} 
      pauseOnHover={true} 
      hideProgressBar={true}
      icon={true} 
      toastStyle={{
        borderRadius: "13px",
        width: "230px",
        height: "40px",
        minHeight: "40px",
        fontSize: "13px",
        padding: "10px 16px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
      }}
    />
  </Provider>
);
